import {
  isEnRouteShippingOrder,
  isCompletedShippingOrder
} from 'shared/models/order';

export function getShippingOption(order) {
  if (order.shipping_name) {
    const match = order.shipping_name.match(/\s+\(.*\)/);
    const name = match
      ? order.shipping_name.slice(0, match.index)
      : order.shipping_name;
    const estimate = match ? match[0].slice(2, -1) : '';
    return { name, estimate };
  } else {
    return {};
  }
}

export function getTrackingCode(order) {
  if (isEnRouteShippingOrder(order) || isCompletedShippingOrder(order)) {
    return order.shipping_tracking || '';
  }
}

export function getTrackingLink(order) {
  if (isEnRouteShippingOrder(order) || isCompletedShippingOrder(order)) {
    return order.easypost_tracking_url || '';
  }
}

export function getStatusInfo(order = {}) {
  const eta = order.eta || {};
  return { title: eta.progress, description: eta.progress_subtitle };
}

export function getProgressSteps(order) {
  const tracking_state = order.tracking_state || {};
  return {
    count: tracking_state.num_states,
    currentStep: tracking_state.current_state
  };
}

export function getCardInfo(order = {}) {
  const card = order.card || {};
  return { brand: card.brand, last4: card.last4 };
}
